import React, { Component, Fragment } from 'react'
import DashboardLayout from '../components/Admin/DashboardLayout'
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'
import AdminApi from '../api/admin-api/admin-api'
import { toast } from 'react-toastify'
import moment from 'moment'

class AdminDashboardLeads extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leadList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      viewdata: '',
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Lead Source',
            field: 'name',
            width: 380,
          },
          {
            label: 'Created On',
            field: 'created',
            width: 150,
          },
          {
            label: 'Edit',
            field: 'edit',
            sort: 'disabled',
            width: 70,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'disabled',
            width: 70,
          },
        ],
        rows: [],
      },
    } // state end
  }

  componentDidMount() {
    this.fetchLeadSourceData()
  }

  //convert date from sec to current date
  toDateTime = secs => {
    let t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeleteLeadSource = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { leadList } = this.state
    if (leadList && leadList.length) {
      let rows = leadList.map(row => {
        const { ls_name, created_at, id } = row
        const submittedDate = (
          <span data-searchvalue={created_at ? moment(created_at).format('YYYY/MM/DD') : ''}>
            {created_at ? moment(created_at).format('MM/DD/YYYY') : 'N/A'}
          </span>
        )
        const self = this

        function editLeadSource() {
          self.props.history.push(`/add-leads/${id}/edit`)
        }

        function deleteLeadSource() {
          self.confirm_DeleteLeadSource({ viewdata: row })
        }

        const editClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={editLeadSource}>
              <MDBIcon icon='edit' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deleteLeadSource}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        return {
          name: <span data-searchvalue={ls_name}>{ls_name}</span>,
          created: submittedDate,
          edit: editClick,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  //Fetch data
  fetchLeadSourceData = async () => {
    this.setState({ loading: true })

    try {
      const result = await AdminApi.getLeadSourcesSortByName()
      const leads = result.data.data || []

      this.setState({ leadList: leads, loading: false }, () => {
        this.setRows()
      })
    } catch (error) {
      this.setState({ loading: false })
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  //Delete data
  _DeleteLeadSource = async id => {
    this.setState({ deleting: true })
    const data = {
      type: 'leadsource',
      id: id,
    }

    AdminApi.deleteLeadSource(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Lead Source successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchLeadSourceData()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { data, confirmModal, loading } = this.state

    const createNew = () => {
      this.props.history.push('/add-leads')
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Lead Sources
                <div className='d-inline-block'>
                  <MDBBtn
                    type='button'
                    color='default'
                    tag='a'
                    floating
                    gradient='blue'
                    title={'Add Lead Source'}
                    onClick={createNew}
                  >
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              <hr />
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <div className='content-wrapper'>
                  <MDB4Datatable
                    data={data}
                    sortRows={['name', 'created']}
                    order={['name', 'asc']}
                    striped
                    bordered
                    small
                    entriesOptions={[10, 20, 50]}
                    exportToCSV
                  />
                </div>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Lead Source</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this Lead Source?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeleteLeadSource(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminDashboardLeads
